import { GetterTree } from 'vuex';
import { ISidebarState } from './Interface';
import { IRootState } from '../../store';

export const getters: GetterTree<ISidebarState, IRootState> = {
    sidebarShow: (state) => {
        return state.sidebarShow;
    },
};
